import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {GetLimits_limits as Limits} from 'nutshell-graphql-types';

import {useGetAvailablePlans} from '../../setup/billing/graphql/hooks/use-get-available-plans';

import {GateContentLayout} from './gate-content-layout';
import {findPlanByName} from './helpers';
import {ManagePlanLink} from './manage-plan-link';
import {NotInPlanAdminContent} from './not-in-plan-admin-content';

interface Props {
    isAdmin: boolean;
    featureName?: string;
    limits: Limits | null;
    onClose: () => void;
    minimumPlanName?: string;
    isLoadingAiFeature: boolean;
}

export function NotInPlanContent(props: Props) {
    const {crm, isLoading} = useGetAvailablePlans(!props.isAdmin);
    const isLoadingPlans = isLoading && !crm;

    const planName = props.minimumPlanName || props.limits?.upgradePlanName || '';
    const upgradePlan = crm?.plans ? findPlanByName(crm.plans, planName) : undefined;

    if (props.isAdmin) {
        return (
            <GateContentLayout
                onClose={props.onClose}
                footerAction={<ManagePlanLink onClose={props.onClose} />}
            >
                <NotInPlanAdminContent
                    limits={props.limits}
                    featureName={props.featureName}
                    isLoading={isLoadingPlans || props.isLoadingAiFeature}
                    upgradePlan={upgradePlan}
                    planName={planName}
                />
            </GateContentLayout>
        );
    }

    return (
        <GateContentLayout onClose={props.onClose} centerContent={true}>
            <Stack spacing={16}>
                <Body size='xlarge' isBold={true} color='dark'>
                    This feature is available on higher plans
                </Body>
                <Body>
                    Contact your account admin to upgrade your team's plan and continue using it.
                </Body>
            </Stack>
        </GateContentLayout>
    );
}
